export default function dayInRange(Utils, dateFilter, $rootScope) {
  'ngInject';

  return {
    require: ['^?datepickerCustomRangePicker', '^ngModel'],
    link($scope, $element, $attrs, [rangePickerCtrl, ngModel]) {
      if (toDate(ngModel.$viewValue) === toDate($scope.dt.date)) {
        $element.addClass('model-selected');
      }

      if (rangePickerCtrl) {
        const { date } = $scope.dt;
        $scope.$watch(
          () => {
            const { rangeStart, rangeEnd, hoveredDate, hoveredOnLeftPicker } = rangePickerCtrl;
            return JSON.stringify({ rangeStart, rangeEnd, hoveredDate, hoveredOnLeftPicker });
          },
          () => {
            const { rangeStart, rangeEnd, hoveredDate, hoveredOnLeftPicker } = rangePickerCtrl;
            toggleClasses('day-in-range', rangeStart, rangeEnd, date);

            if (hoveredDate) {
              if (hoveredOnLeftPicker) {
                const potentialRangeEnd = hoveredDate < rangeEnd ? rangeEnd : hoveredDate;
                toggleClasses('hover-in-range', hoveredDate, potentialRangeEnd, date);
              } else {
                toggleClasses('hover-in-range', rangeStart, hoveredDate, date);
              }
            } else {
              $element.removeClass('hover-in-range');
              $element.removeClass('hover-in-range-first');
              $element.removeClass('hover-in-range-last');
            }
          }
        );

        $element.on('mouseenter', () => {
          if ($scope.dt.disabled) {
            return;
          }

          rangePickerCtrl.hoveredDate = date;

          const { rangeStart } = rangePickerCtrl;
          rangePickerCtrl.hoveredOnLeftPicker = toDate(ngModel.$viewValue) === toDate(rangeStart);

          if (!$rootScope.$$phase) {
            $scope.$apply();
          }
        });

        $element.on('mouseleave', () => {
          if ($scope.dt.disabled) {
            return;
          }

          rangePickerCtrl.hoveredDate = null;
          if (!$rootScope.$$phase) {
            $scope.$apply();
          }
        });
      }

      function toggleClasses(className, from, to, date) {
        if (from <= date && date <= to) {
          $element.addClass(className);
        } else {
          $element.removeClass(className);
        }

        if (toDate(from) === toDate(date)) {
          $element.addClass(`${className}-first`);
        } else {
          $element.removeClass(`${className}-first`);
        }

        if (toDate(to) === toDate(date)) {
          $element.addClass(`${className}-last`);
        } else {
          $element.removeClass(`${className}-last`);
        }
      }
    },
  };

  function toDate(date) {
    return dateFilter(date, 'yyyy-MM-dd');
  }
}
